import React from 'react';
import { Show, TextField, BooleanField, TabbedShowLayout, Tab } from 'react-admin';

import { DateField } from '../customFields';
import DeviceTypeTitle from './DeviceTypeTitle';

const DeviceTypeShow = (props) => (
	<Show title={<DeviceTypeTitle />} {...props}>
		<TabbedShowLayout>
			<Tab label="Details">
				<TextField source="index" />
				<TextField source="name" />
				<BooleanField source="active" />
				<DateField source="createdAt" />
				<DateField source="updatedAt" />
				<TextField source="createdBy" />
				<TextField source="updatedBy" />
			</Tab>
		</TabbedShowLayout>
	</Show>
);

export default DeviceTypeShow;
